import _ from "lodash";
import client from "lib/apolloClient/client";
import update from "immutability-helper";

import { setToastMsg } from "Login/modules/LoginModule/LoginActions";
import { updateSchoolLoginConfigMutation } from "./LoginPageConfigurationMutation";
import {
  previewOptions,
  TAB_TYPES,
  USER_TYPES,
} from "./LoginPageConfigurationUtils";
import { getOrganizationDetailsQuery } from "./LoginPageConfigurationQuery";

export const NAME = "loginPageConfiguration";
export const TOGGLE_LOADER = "TOGGLE_LOADER";
export const UPDATE_ACTIVE_TAB = "UPDATE_ACTIVE_TAB";
export const UPDATE_ACTIVE_APP = "UPDATE_ACTIVE_APP";
export const UPDATE_ACTIVE_PREVIEW = "UPDATE_ACTIVE_PREVIEW";
export const UPDATE_ACTIVE_WEB_LOGIN_TYPE = "UPDATE_ACTIVE_WEB_LOGIN_TYPE";

export const updateSchoolLoginConfigDetails = ({
  loginConfigDetails = {},
  variables,
  refetch = false,
}) => {
  return async dispatch => {
    try {
      const result = await client.mutate({
        mutation: updateSchoolLoginConfigMutation,
        variables: {
          input: loginConfigDetails,
        },
        awaitRefetchQueries: refetch,
        refetchQueries: refetch
          ? [
              {
                query: getOrganizationDetailsQuery,
                variables,
              },
            ]
          : [],
      });

      const res = _.get(
        result,
        "data.organizationManagement.upsertSchoolLoginConfig",
        false
      );

      const isSuccess = _.get(res, "isSuccess", false);
      const schoolCode = _.get(res, "data.schoolCode", null);

      if (!isSuccess) {
        dispatch(
          setToastMsg(
            _.get(
              result,
              "data.organizationManagement.upsertSchoolLoginConfig.message",
              "Something went wrong"
            )
          )
        );
      }

      return { isSuccess, schoolCode };
    } catch (e) {
      dispatch(
        setToastMsg({
          msg: "toastMsgs:something_went_wrong",
          type: "error",
        })
      );
    }
  };
};

export const handleUpdateActivePreview = value => {
  return dispatch => {
    dispatch({
      type: UPDATE_ACTIVE_PREVIEW,
      payload: Number(value),
    });
  };
};

export const handleUpdateActiveTab = value => {
  return dispatch => {
    dispatch({
      type: UPDATE_ACTIVE_TAB,
      payload: value,
    });
  };
};

export const handleUpdateActiveApp = value => {
  return dispatch => {
    dispatch({
      type: UPDATE_ACTIVE_APP,
      payload: value,
    });
  };
};

export const handleUpdateActiveWebLoginType = value => {
  return dispatch => {
    dispatch({
      type: UPDATE_ACTIVE_WEB_LOGIN_TYPE,
      payload: value,
    });
  };
};

export const handleToggleLoader = value => {
  return dispatch => {
    dispatch({
      type: TOGGLE_LOADER,
      payload: value,
    });
  };
};

const REDUCER_HANDLERS = {
  [UPDATE_ACTIVE_TAB]: (state, action) => {
    return update(state, { tab: { $set: action.payload } });
  },
  [UPDATE_ACTIVE_APP]: (state, action) => {
    return update(state, { app: { $set: action.payload } });
  },
  [UPDATE_ACTIVE_PREVIEW]: (state, action) => {
    return update(state, {
      preview: { $set: action.payload },
    });
  },
  [UPDATE_ACTIVE_WEB_LOGIN_TYPE]: (state, action) => {
    return update(state, { webLoginType: { $set: action.payload } });
  },
  [TOGGLE_LOADER]: (state, action) => {
    return update(state, { showLoader: { $set: action.payload } });
  },
};

const initialState = {
  app: USER_TYPES.staff,
  tab: TAB_TYPES.web,
  preview: previewOptions[0].key,
  webLoginType: null,
  showLoader: false,
};

export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
